import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';
import SalesIndex from './Index.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/sales'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'sales_report_index',
          component: SalesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
